<template>
    <div>
        <form @submit.prevent="updateMembers()">
        	<div class="form-group">
                <label for="group_name">Group Name</label>
    			<input id="group_name" class="form-control" v-model="name" placeholder="Group Name" />
        	</div>
			<div class="form-group">
				<label for="capacity">Capacity</label>
				<input id="capacity" class="form-control" v-model="capacity" placeholder="Capacity" />
			</div>
        	<div class="form-group">
                <label for="members">Group Members</label>
	            <multiselect v-model="members" :options="memberOptions" track-by="id" label="name" name="members" id="members" @input="" :multiple="true" :closeOnSelect="false" :hideSelected="true"></multiselect>
	        </div>
            <hr>
            <div class="form-group pull-right">
				<button class="btn btn-success" type="button" @click="cancelEditing">Cancel</button>
                <button class="btn btn-primary" type="submit">Update Group</button>
            </div>
        </form>
    </div>
</div>
</template>

<script>
    import Form from '../utils/Form';

    export default {
        props: {
            group: Object,
            memberOptions: Array,
        },

        data: function () {
            return {
				members: this.group.members,
				options: this.memberOptions,
				capacity: this.group.capacity,
				name: this.group.name
            };
        },

        mounted() {
        	if (this.options.length == 0) {
        		this.getMembers();
        	}
        },

        methods: {
            getMembers() {
                // axios.get(`/api/v1/timeslots/${this.timeslotId}/members`)
                axios.get(`/api/v1/members`)
                    .then(response => {
                    	console.log(response);
                        this.options = response.data;
                    })
                    .catch(error => {
                        console.log(error);
                        this.$message({message: 'There was a problem fetching members.', type: 'error'});
                    });
            },

            updateMembers() {
            	console.log('updateMembers');
                axios.put(`/api/v1/groups/${this.group.id}`, {
                	name: this.name,
					capacity: this.capacity,
                	members: _.map(this.members, 'id')
                })
                .then(response => {
                	console.log(response);
                    this.$vuedals.close();
                    this.$parent.$emit('group-members-changed', { selectedMembers: this.members, groupId: this.group.id });
                })
                .catch(error => {
                	console.log(error);
                    this.$message({message: 'There was a problem updating members.', type: 'error'});
                });
            },
			cancelEditing()
			{
				this.$vuedals.close();
			}
        },

        destroyed() {
            // this.form = null;
        }
    }
</script>
